if (process.env.NODE_ENV !== 'production') {
  for (const a of document.querySelectorAll<HTMLAnchorElement>(
    'a[data-href]'
  )) {
    a.href = a.getAttribute('data-href')!
  }
}
